import { useEffect, useMemo, useState } from 'react';
import { components } from '../components';
import apiService from '../service/ApiService';
import _, { isEmpty } from 'lodash';
import utils from '../helpers/utils';
import { TabView } from '../components/TabView';
import giftIcon from '../assets/icons/11.png';
import dateHelper from '../helpers/dateHelper';
import constants from '../helpers/constants';
import happy_stars from '../assets/icons/happy_stars.jpg';
import redStart from '../assets/icons/redstar.png';
import emptyList from '../assets/icons/emptyList.jpg';

export const PointLogScreen: React.FC = () => {
  const [opacity, setOpacity] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(true);
  const [current, setCurrent] = useState(0);
  const [state, setState] = useState<any>({
    userPoints: [],
    filteredPoints: [],
    totalBalance: 0,
  });

  const tabIndex: any = {
    0: 'all',
    1: 'credit',
    2: 'debit',
    3: 'learn',
  };

  useEffect(() => {
    getPointLog();
  }, []);

  const activeButton = useMemo(() => {
    if (current !== -1) {
      setIsLoading(true);

      const tab = tabIndex[current];
      let updatedPoints = state.userPoints;
      if (tab === 'credit') {
        updatedPoints = state.userPoints.filter((item: any) => item.credit > 0);
      } else if (tab === 'debit') {
        updatedPoints = state.userPoints.filter((item: any) => item.debit > 0);
      }
      setState({
        ...state,
        filteredPoints: updatedPoints,
      });
      setIsLoading(false);

      return tab;
    }
  }, [current]);

  const getPointLog = async () => {
    setIsLoading(true);
    const { data } = await apiService.getPointLogAsync();
    if (data) {
      const sumOfCredits = _.sumBy(data, 'credit');
      const sumOfDebits = _.sumBy(data, 'debit');
      const totalPoints = sumOfCredits - sumOfDebits;
      let updatedPoints = data;
      if (activeButton === 'credit') {
        updatedPoints = data.filter((item: any) => item.credit > 0);
      } else if (activeButton === 'debit') {
        updatedPoints = data.filter((item: any) => item.debit > 0);
      }
      setState({
        ...state,
        userPoints: data,
        filteredPoints: updatedPoints,
        totalBalance: totalPoints,
      });
    }
    setIsLoading(false);
  };

  const renderFaqs = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <img
          src={happy_stars}
          alt=''
          style={{ width: '50%', height: '50%' }}
        ></img>
        <p style={{ fontWeight: 700 }}>FAQs</p>
        {_.map(constants.refFAQs, (faqData, index) => {
          return (
            <div
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                marginBottom: 20,
              }}
            >
              <img src={redStart} style={{ height: 30, width: 30 }} alt='' />
              <div style={{ width: '85%', paddingLeft: 10 }}>
                <p style={{ marginBottom: 5, fontWeight: 700 }} className='t16'>
                  {faqData.question}
                </p>
                <p className='t14'>{faqData.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderTabContent = (items: any): JSX.Element => {
    return (
      <>
        {!isEmpty(items) ? (
          items.map((item: any, index: number) => (
            <div
              key={index}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'var(--white-color)',
                border: 'var(--white-color)',
                borderRadius: '12px',
                paddingBottom: '16px',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  flex: '0 0 60px',
                  height: '50px',
                  width: '50px',
                  background: '#f4f4f4',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '22px',
                  marginRight: '16px',
                }}
              >
                <img
                  src={giftIcon}
                  alt={'store-icon'}
                  style={{
                    width: 20,
                    fill: 'var(--white-color)',
                    background: 'var(--white-color)',
                    height: 20,
                    objectFit: 'contain',
                  }}
                />
              </div>
              <div style={{ flex: 1 }} className='t14'>
                <p style={{ flexWrap: 'wrap' }}>{item.description}</p>
                <p
                  style={{ marginTop: 4, color: 'var(--text-color)' }}
                  className='t12'
                >
                  {dateHelper.displayFromNow(item.transDate)}
                </p>
              </div>
              <div className='t14'>
                <p
                  style={{
                    color:
                      item.transType === 'earn'
                        ? 'var( --button-color)'
                        : 'var(--accent-color)',
                  }}
                >
                  {item.transType === 'earn' ? '+' : '-'}
                  {utils.formatNumber(
                    item.transType === 'earn' ? item.credit : item.debit
                  )}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '65vh',
            }}
          >
            <img
              src={emptyList}
              alt='no data'
              style={{ width: '50%', height: '50%' }}
            />
            <p className='t16'>No Record Found</p>
          </div>
        )}
      </>
    );
  };

  const items = [
    { label: 'All', content: renderTabContent(state.filteredPoints) },
    { label: 'Received', content: renderTabContent(state.filteredPoints) },
    { label: 'Spent', content: renderTabContent(state.filteredPoints) },
    {
      label: 'Learn More',
      // disabled: true,
      content: renderFaqs(),
    },
  ];

  const renderLoader = (): JSX.Element | null => {
    if (!isLoading) return null;
    return (
      <div>
        <components.Loader />
      </div>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <div>
        <section
          style={{
            padding: 10,
            borderRadius: 10,
            backgroundColor: 'var(--white-color)',
            marginTop: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <span
              className='t18 number-of-lines-1'
              style={{
                marginBottom: 8,
                textTransform: 'capitalize',
              }}
            >
              Your Star Balance{' '}
            </span>
            <span
              className='t20 number-of-lines-1'
              style={{
                marginBottom: 8,
                textTransform: 'capitalize',
              }}
            >
              {utils.formatNumber(state.totalBalance)}
            </span>
          </div>
        </section>
        <section
          style={{
            padding: 10,
            borderRadius: 10,
            backgroundColor: 'var(--white-color)',
            marginTop: 10,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span
              className='t16 number-of-lines-1'
              style={{
                fontWeight: 500,
                marginBottom: 8,
                color: 'var(--main-color)',
                textTransform: 'capitalize',
              }}
            >
              <TabView
                tabs={items}
                index={current}
                onChange={setCurrent}
                autoFocusActive
                isLoading={isLoading}
              />
            </span>
          </div>
        </section>
      </div>
    );
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header showGoBack={true} title='Points' />;
  };

  return (
    <>
      {renderHeader()}
      <div id='screen' style={{ opacity, padding: '0px 20px' }}>
        {renderLoader()}
        {renderContent()}
      </div>
    </>

  );
};
